/* tslint:disable */
/* eslint-disable */
/**
 * Areeb Supplier API
 * Areeb Supplier REST API
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CreateWarehouseDto
 */
export interface CreateWarehouseDto {
    /**
     * Warehouse name
     * @type {string}
     * @memberof CreateWarehouseDto
     */
    name: string;
    /**
     * Country code where warehouse is located
     * @type {string}
     * @memberof CreateWarehouseDto
     */
    countryCode: string;
    /**
     * Whether warehouse is active
     * @type {boolean}
     * @memberof CreateWarehouseDto
     */
    isActive?: boolean;
    /**
     * Contact info ID (optional, used if existing contact info)
     * @type {number}
     * @memberof CreateWarehouseDto
     */
    contactInfoId?: number;
    /**
     * Contact phone number
     * @type {string}
     * @memberof CreateWarehouseDto
     */
    phoneNumber?: string;
    /**
     * Street address
     * @type {string}
     * @memberof CreateWarehouseDto
     */
    street?: string;
    /**
     * Building number
     * @type {string}
     * @memberof CreateWarehouseDto
     */
    buildingNumber?: string;
    /**
     * Formatted address for display
     * @type {string}
     * @memberof CreateWarehouseDto
     */
    formattedAddress?: string;
    /**
     * Latitude
     * @type {number}
     * @memberof CreateWarehouseDto
     */
    latitude?: number;
    /**
     * Longitude
     * @type {number}
     * @memberof CreateWarehouseDto
     */
    longitude?: number;
}

/**
 * Check if a given object implements the CreateWarehouseDto interface.
 */
export function instanceOfCreateWarehouseDto(value: object): value is CreateWarehouseDto {
    if (!('name' in value) || value['name'] === undefined) return false;
    if (!('countryCode' in value) || value['countryCode'] === undefined) return false;
    return true;
}

export function CreateWarehouseDtoFromJSON(json: any): CreateWarehouseDto {
    return CreateWarehouseDtoFromJSONTyped(json, false);
}

export function CreateWarehouseDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreateWarehouseDto {
    if (json == null) {
        return json;
    }
    return {
        
        'name': json['name'],
        'countryCode': json['countryCode'],
        'isActive': json['isActive'] == null ? undefined : json['isActive'],
        'contactInfoId': json['contactInfoId'] == null ? undefined : json['contactInfoId'],
        'phoneNumber': json['phoneNumber'] == null ? undefined : json['phoneNumber'],
        'street': json['street'] == null ? undefined : json['street'],
        'buildingNumber': json['buildingNumber'] == null ? undefined : json['buildingNumber'],
        'formattedAddress': json['formattedAddress'] == null ? undefined : json['formattedAddress'],
        'latitude': json['latitude'] == null ? undefined : json['latitude'],
        'longitude': json['longitude'] == null ? undefined : json['longitude'],
    };
}

export function CreateWarehouseDtoToJSON(value?: CreateWarehouseDto | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'name': value['name'],
        'countryCode': value['countryCode'],
        'isActive': value['isActive'],
        'contactInfoId': value['contactInfoId'],
        'phoneNumber': value['phoneNumber'],
        'street': value['street'],
        'buildingNumber': value['buildingNumber'],
        'formattedAddress': value['formattedAddress'],
        'latitude': value['latitude'],
        'longitude': value['longitude'],
    };
}

